import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Footer from "../../utils/footer";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What types of properties does Thakkar Realtors specialize in?",
      answer:
        "Thakkar Realtors specializes in a wide range of properties, including residential, commercial, and investment properties.",
    },
    {
      question: "What regions does Thakkar Realtors operate in?",
      answer:
        "We operate primarily across Navi Mumbai, Panvel, and nearby areas, providing premium properties and professional real estate services.",
    },
    {
      question: "Does Thakkar Realtors provide property management services?",
      answer:
        "Yes, we offer complete property management services, including rental assistance, maintenance, and documentation support.",
    },
    {
      question: "How can I search for available properties on the Thakkar Realtors website?",
      answer:
        "You can easily browse through our listed properties using the 'Property' section, which allows filtering by location, type, and price range.",
    },
    {
      question: "What sets Thakkar Realtors apart in the real estate market?",
      answer:
        "We stand out through transparency, trusted client relationships, and over 10 years of experience delivering value and satisfaction.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Animation variants for scroll and reveal
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, delay },
    }),
  };

  return (
    <>
    <div className="pt-28 bg-gradient-to-br from-white via-gray-50 to-blue-50 text-gray-800 overflow-hidden">
      {/* Header Section */}
      <motion.section
        className="text-center py-10 bg-white shadow-sm"
        variants={fadeUp}
        initial="hidden"
        animate="visible"
      >
        <h1 className="text-3xl font-bold text-gray-900">
          Frequently Asked <span className="text-blue-600">Questions</span>
        </h1>
        <p className="text-gray-500 mt-2">
          Here are some of the most common questions our clients ask us.
        </p>
      </motion.section>

      {/* FAQ Section */}
      <section className="max-w-4xl mx-auto py-5 px-6">
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            className={`border-b border-gray-200 py-4 cursor-pointer rounded-md ${
              activeIndex === index ? "bg-blue-50 border-blue-300" : "hover:bg-gray-50"
            }`}
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={index * 0.1}
            onClick={() => toggleFAQ(index)}
            whileHover={{ scale: 1.01 }}
            transition={{ duration: 0.3 }}
          >
            {/* Question */}
            <div className="flex justify-between items-center py-3 px-4 transition-all">
              <motion.h3
                className={`font-medium text-lg ${
                  activeIndex === index
                    ? "text-blue-600"
                    : "text-gray-800 hover:text-blue-600"
                }`}
                whileHover={{ x: 3 }}
              >
                {faq.question}
              </motion.h3>
              <motion.span
                className={`text-2xl ${
                  activeIndex === index ? "text-blue-600" : "text-gray-400"
                }`}
                initial={{ rotate: 0 }}
                animate={{ rotate: activeIndex === index ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              >
                {activeIndex === index ? "−" : "+"}
              </motion.span>
            </div>

            {/* Animated Answer */}
            <AnimatePresence initial={false}>
              {activeIndex === index && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  <p className="text-gray-600 mt-2 ml-5 pb-3 pr-2 leading-relaxed">
                    {faq.answer}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </section>

      {/* Animated CTA Section */}
      {/* <motion.section
        className="bg-blue-600 text-white py-14 px-6 overflow-hidden relative"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      > */}
        {/* floating background shapes for subtle animation */}
        {/* <motion.div
          className="absolute top-0 left-0 w-72 h-72 bg-blue-400 rounded-full blur-3xl opacity-20"
          animate={{ x: [0, 50, 0], y: [0, 30, 0] }}
          transition={{ duration: 10, repeat: Infinity }}
        /> */}
        {/* <motion.div
          className="absolute bottom-0 right-0 w-64 h-64 bg-blue-300 rounded-full blur-3xl opacity-20"
          animate={{ x: [0, -50, 0], y: [0, -30, 0] }}
          transition={{ duration: 12, repeat: Infinity }}
        /> */}

        {/* <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row justify-between items-center gap-6">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-2xl font-bold mb-2">
              Still Have <span className="text-blue-100">Questions?</span>
            </h2>
            <p className="text-blue-100">
              We’re always here to help — get in touch with our team today!
            </p>
          </motion.div>
          <motion.button
            className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-blue-50 transition"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact Us
          </motion.button>
        </div> */}
      {/* </motion.section> */}
    </div>
      <Footer />
      </>
  );
};

export default FAQ;
